import { useQuery } from "@tanstack/react-query";
import GatewayService from "../services/GatewayService";

function useGetPersonIdFromUser(userId: string) {
  const result = useQuery<{ person: { id: string } }>({
    queryKey: ["user", userId],
    queryFn: () => GatewayService.getPersonId(userId),
    retry: false,
    enabled: !!userId,
  });

  return {
    ...result,
    user: result.data,
  };
}

export { useGetPersonIdFromUser };
